class LocStore{
	constructor(){

	}

	initLS(name){
		let ini = localStorage.getItem(name);
		//console.log( name, '|init: ', ini, '|', ini===null)
		if ( ini === null || ini.length < 1) {
			localStorage.setItem(name, '');
			return;
		}
		if ( ini.search(';') !== -1 ) {
			return ini.split(';');
		} 
		return ini;
	}

	getLS(name){
		let arr=[];
		let array = localStorage.getItem(name); // array = string
		//console.log( name, '|Array: ', array, ' !: ', !array )
		if( !array ) localStorage.setItem(name, '');
		//if( array === undefined || array === null ) localStorage.setItem(name, '');
		if( array.search(';') !== -1 ){
			arr = array.split(';');
		}
		if( array.search(';') === -1 && array['length'] > 1 ){
			arr.push(array);
		}
		return arr; //return array
	}

	setLS(name, str) {
		if(localStorage.getItem(name) === undefined){
			localStorage.setItem(name, str);
			return;
		}
		let arr=[];
		let array = localStorage.getItem(name);
		if( array['length'] < 2 ){
			arr.push(str);
		} else {
			arr = array.split(';');
			if( !arr.includes(str) ) arr.push(str);
		}
		arr = arr.join(';');
		localStorage.setItem(name, arr);
		return arr;// return string
	}

	remLS(name, str) {
		let arr = [];
		let array = localStorage.getItem(name);
		let res='';
		if( array.search(';') !== -1){
			arr = array.split(';');
			res = arr.filter( el => {
				return el !== str
			}).join(';');
			localStorage.setItem(name, res);
			return;
		}
		if( array.search(';') === -1){
			if( array !== str ) res = array;
			localStorage.setItem(name, res);
		}
		return false;
	}

	delLS(name) {
		localStorage.setItem(name, '');
	}
}

export default LocStore;